"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingUserInfoViewWrap = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styles_1 = require("@material-ui/styles");
var index_1 = require("../../../index");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    UserInfoView: {
        display: "flex",
        alignItems: "center",
        height: 100,
        padding: 20,
        borderStyle: "solid",
        borderWidth: 1,
        borderRadius: 5,
        borderColor: theme
            ? theme.app.SettingUserInfoView.borderColor
            : "",
        backgroundColor: theme
            ? theme.app.SettingUserInfoView.backgroundColor
            : "",
    },
    UserInfoView_icon: {
        width: 100,
        height: 100,
        marginRight: 20,
        borderRadius: 50,
    },
    UserInfoView_information: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        height: 100,
    },
    UserInfoView_top: {
        display: "flex",
        justifyContent: "space-between",
        height: 38,
        marginBottom: 20,
    },
    UserInfoView_text: {
        height: 16,
        fontSize: 12,
        fontWeight: 600,
        marginBottom: 4,
        color: theme
            ? theme.app.SettingUserInfoView.UserInfoView_text
            : "",
    },
    UserInfoView_name: {
        height: 18,
        fontSize: 14,
        fontWeight: 400,
        color: theme
            ? theme.app.SettingUserInfoView.UserInfoView_name
            : "",
    },
    UserInfoView_namecode: {
        fontSize: 14,
        fontWeight: 400,
        color: theme
            ? theme.app.SettingUserInfoView.UserInfoView_namecode
            : "",
    },
    UserInfoView_email: {
        height: 17,
        fontSize: 14,
        fontWeight: 400,
        color: theme
            ? theme.app.SettingUserInfoView.UserInfoView_name
            : "",
    },
}); });
function SettingUserInfoViewWrap(props) {
    var url = props.url, text = props.text, code = props.code, desc = props.desc, onClick = props.onClick;
    var classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.UserInfoView },
        react_1.default.createElement("div", null,
            react_1.default.createElement("img", { className: classes.UserInfoView_icon, src: url })),
        react_1.default.createElement("div", { className: classes.UserInfoView_information },
            react_1.default.createElement("div", { className: classes.UserInfoView_top },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: classes.UserInfoView_text }, "\u7528\u6237\u540D"),
                    react_1.default.createElement("div", { className: classes.UserInfoView_name },
                        text,
                        react_1.default.createElement("span", { className: classes.UserInfoView_namecode }, code))),
                react_1.default.createElement(index_1.SettingPrimaryButton, { onClick: onClick }, "\u7F16\u8F91")),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: classes.UserInfoView_text }, "\u7535\u5B50\u90AE\u7BB1"),
                react_1.default.createElement("div", { className: classes.UserInfoView_email }, desc)))));
}
exports.SettingUserInfoViewWrap = SettingUserInfoViewWrap;
//# sourceMappingURL=SettingUserInfoViewWrap.js.map